import { GoalSortingMode } from 'shared/types/sorting-mode';
import styled, { css } from 'styled-components';

export const Container = styled.ul`
  position: sticky;
  top: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  margin: 0;
  padding: 0;
  width: 100%;

  list-style: none;
  background: ${({ theme }) => theme.palette.background.default};
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  padding: ${({ theme }) => `0 ${theme.spacing(18.5)} 0 ${theme.spacing(4)}`};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      display: none;
    `};
`;

export const Item = styled.li<{ $mode: GoalSortingMode }>`
  flex: 0 0 auto;

  ${({ $mode }) => {
    switch ($mode) {
      case GoalSortingMode.Name:
        return css`
          flex: 1;
        `;
      case GoalSortingMode.Progress:
        return css`
          width: 8.4rem;
        `;
      case GoalSortingMode.Impact:
        return css`
          width: 8.8rem;
          display: none;

          @container goal-list (min-width: 60rem) {
            display: list-item;
          }
        `;
      case GoalSortingMode.StartDate:
        return css`
          width: 8.8rem;
          display: none;

          @container goal-list (min-width: 80rem) {
            display: list-item;
          }
        `;
      case GoalSortingMode.Deadline:
        return css`
          width: 8.8rem;
        `;
      case GoalSortingMode.Tasks:
        return css`
          width: 8.8rem;
          display: none;

          @container goal-list (min-width: 70rem) {
            display: list-item;
          }
        `;
      case GoalSortingMode.LifeArea:
        return css`
          width: 16.6rem;
          display: none;

          @container goal-list (min-width: 95rem) {
            display: list-item;
          }
        `;
      default:
        return '';
    }
  }}
`;

export const Button = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  margin: 0;
  padding: ${({ theme }) => `${theme.spacing(1.5)} 0`};
  background: transparent;

  border: none;
  cursor: pointer;
  transition: color 200ms;

  text-align: left;
  color: ${({ theme }) => theme.palette.text.secondary};

  ${({ $active, theme }) =>
    $active &&
    css`
      color: ${theme.palette.text.primary};
    `}

  &:hover {
    ${({ $active }) =>
      !$active &&
      css`
        opacity: 0.8;
      `}
  }
`;

export const DirectionIcon = styled.span<{ $desc: boolean }>`
  display: flex;
  align-items: center;

  font-size: 1.2rem;
  line-height: 62.5%;

  transition: transform 200ms;
  transform: rotate(${({ $desc }) => ($desc ? '180deg' : '0deg')});
`;
